import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useShowNotification } from '../../../hooks/useShowNotification';

export const FormModal = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const { notificationTitle, notificationIcon } = props;
    const showNotification = useShowNotification(notificationTitle, notificationIcon);

    const { model = null, form: Form, onSucceed, onFailed, action } = props;
    const { mode = 'show', size = 'md', title, show, onHide } = props;

    const handleSubmit = async (data) => {
        try {
            if (isLoading) {
                return;
            }

            setIsLoading(true);
            onHide();

            const response = await action(data);
            setIsLoading(false);

            if (!response.success) {
                showNotification(response.message, 'warning');
                handleFail(response);
                return;
            }

            showNotification(response.message, 'success');
            handleSuccess(response);
        } catch (error) {
            handleFail(error);
            setIsLoading(false);
            showNotification('Oops something went wrong.', 'danger');
        }
    };

    const handleReset = () => {
        onHide();
    };

    const handleSuccess = (response) => {
        if (onSucceed) {
            onSucceed(response);
        }
    };

    const handleFail = (error) => {
        if (onFailed) {
            onFailed(error);
        }
    };

    return (
        <Modal size={size} show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form model={model} mode={mode} onSubmit={handleSubmit} onReset={handleReset} />
            </Modal.Body>
        </Modal>
    );
};
